<sc-padding class="no-field-space">

  <sc-sub-title><sc-dictionary-label dictionaryKey="tmc-yard.supplementaryequipment.ui.supplementaryequipment-property-administration.show-supplementaryequipment"></sc-dictionary-label></sc-sub-title>

  <ac-property-group propertyKey="tmc-yard.supplementaryequipment.pager-enabled"></ac-property-group>
  <ac-property-group propertyKey="tmc-yard.supplementaryequipment.smartphone-enabled"></ac-property-group>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-sub-title><sc-dictionary-label dictionaryKey="tmc-yard.supplementaryequipment.ui.supplementaryequipment-property-administration.show-register-transport"></sc-dictionary-label></sc-sub-title>

  <ac-property-group propertyKey="tmc-yard.supplementaryequipment.hide-in-register-transport"></ac-property-group>
  <ac-property-group propertyKey="tmc-yard.supplementaryequipment.show-pager-in-register-transport"></ac-property-group>
  <ac-property-group propertyKey="tmc-yard.supplementaryequipment.show-smartphones-in-register-transport"></ac-property-group>
  <ac-property-group propertyKey="tmc-yard.supplementaryequipment.show-no-handout"></ac-property-group>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-sub-title><sc-dictionary-label dictionaryKey="tmc-yard.supplementaryequipment.ui.supplementaryequipment-property-administration.general-supplementaryequipment-check"></sc-dictionary-label></sc-sub-title>

  <ac-property-group propertyKey="tmc-yard.supplementaryequipment.check-on-route-start">
    <sc-hint-legacy dictionaryKey="tmc-yard.supplementaryequipment.ui.supplementaryequipment-property-administration.check-on-route-start-hint"></sc-hint-legacy>
  </ac-property-group>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-sub-title><sc-dictionary-label dictionaryKey="tmc-yard.supplementaryequipment.ui.supplementaryequipment-property-administration.supplementaryequipment-check-entrance-leave"></sc-dictionary-label></sc-sub-title>

  <ac-property-group propertyKey="tmc-yard.supplementaryequipment.transport-entrance-check"></ac-property-group>
  <ac-property-group propertyKey="tmc-yard.supplementaryequipment.transport-leave-check"></ac-property-group>

  <sc-content-spacer vertical></sc-content-spacer>

  <ac-property-group propertyKey="tmc-yard.supplementaryequipment.truck-entrance-check"></ac-property-group>
  <ac-property-group propertyKey="tmc-yard.supplementaryequipment.truck-leave-check"></ac-property-group>

</sc-padding>
